/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';

import { LoneIconButton } from '@blend/enterprise-components';

import { emailInputConfig } from 'blb-inputs/common';

import { optionalEmailValidator } from 'blb-utils/validators';
import { RemoveButtonWrapper } from '../styles';

import { isAdminInputConfig } from '../helpers';

export const Row = styled.li`
  display: grid;

  grid-template-columns: 6fr 1fr 1fr;
  align-items: center;
  gap: 0 12px;
  margin-bottom: 8px;
`;

export const InviteMemberRow: React.FC<{
  index: number;
  member: { isAdmin: boolean; username: string; disabled?: boolean; required?: boolean };
  remove: (index: number) => void;
}> = ({ member, index, remove }) => {
  return (
    <Row>
      <Field
        {...emailInputConfig}
        containerStyles={[]}
        customComponentProps={{ disabled: false, type: 'text' }}
        disabled={member.disabled}
        key={`members-${index}-username`}
        label=""
        name={`members[${index}].username`}
        placeholder="Email address"
        validate={optionalEmailValidator}
        value={member.username}
      />

      <Field {...isAdminInputConfig} label={''} name={`members[${index}].isAdmin`} />

      {!member.required && (
        <RemoveButtonWrapper>
          <LoneIconButton
            btnSize="sm"
            icon="delete"
            id={`it-removemember-${index}-btn`}
            isCircle
            onClick={() => remove(index)}
            theme="tertiary"
          />
        </RemoveButtonWrapper>
      )}
    </Row>
  );
};
